// Oval Farms contact details, used across the public website.
// Update them here and every page picks up the change.
export const SITE_INFO = {
  name: 'Oval Farms',
  fullName: 'Oval Hi-Tech Farms',
  tagline: 'Health for those who matter',
  address: 'Head office, Oval Farms, Koothali, Kozhikode 673525, Kerala, India',
  email: 'ovaleggfarm@gmail.com',
  phone: '9605556054',
  phoneDisplay: '+91 96055 56054',
  phoneLink: 'tel:+919605556054',
  whatsappLink: 'https://wa.me/919605556054?text=' + encodeURIComponent('Hi Oval Farms, I would like to order fresh mushrooms.'),
};
